// extracted by mini-css-extract-plugin
export default {"autoCompleteWrapper":"styles_autoCompleteWrapper__P6HZA","autoCompleteBase":"styles_autoCompleteBase__lLIWe"};